const HeaderSection = ({ title }) => (
  <div className="rounded-lg p-6 text-white relative overflow-hidden">
    <div className="relative z-10">
      <h2 className="text-2xl font-semibold text-center">{title}</h2>
    </div>
    <div className="absolute inset-0 bg-[linear-gradient(90deg,#1B75BC_0%,#69D2C9_100%)] mix-blend-multiply"></div>
  </div>
);

export default HeaderSection;
